import { useEffect, useState } from "react";
import { getMessages } from "../lib/api";

export default function PriestMessages() {
  const [threads, setThreads] = useState([]);
  useEffect(() => { getMessages().then((d) => setThreads(d.threads || [])).catch(() => {}); }, []);
  return (
    <div data-testid="priest-messages" className="space-y-5">
      <div>
        <p className="text-xs font-bold uppercase tracking-widest text-[#C6603A]">Inbox</p>
        <h1 className="mt-1 font-heading text-3xl font-bold">Messages</h1>
        <p className="mt-1 text-sm text-[#7A6E64]">Ceremony details, arrival updates, and support conversations.</p>
      </div>
      <div className="flex gap-2">
        {["All", "Bookings", "Support"].map((t, i) => (
          <span key={t} className={`rounded-full px-3 py-1.5 text-xs font-semibold ${i === 0 ? "bg-[#8B1A2B] text-white" : "border border-[#E7DECF] text-[#7A6E64]"}`}>{t}</span>
        ))}
      </div>
      <div className="divide-y divide-[#F0E8DC] rounded-2xl border border-[#Eee3d6] bg-white">
        {threads.map((t) => (
          <div key={t.id} className="flex items-start gap-3 p-4">
            <span className="grid h-10 w-10 place-items-center rounded-full bg-[#8B1A2B] text-sm font-bold text-white">{t.name[0]}</span>
            <div className="flex-1">
              <div className="flex items-center justify-between"><p className="text-sm font-semibold">{t.name}</p><span className="text-xs text-[#8A8072]">{t.time}</span></div>
              <p className="text-xs font-medium text-[#8B1A2B]">{t.ceremony}</p>
              <p className="text-sm text-[#7A6E64]">{t.last}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
